export default __webpack_public_path__ + "static/media/oftmcss-color.1cc03292.svg";